/*
 * @Author: your name
 * @Date: 2021-06-22 13:18:29
 * @LastEditTime: 2021-06-22 14:59:38
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /HR_FE/src/router/page/index.js
 */

export default [
  {
    path: '/',
    name: 'login',
    component: () => import('@/views/Login.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/loginBySms',
    name: 'login',
    component: () => import('@/views/loginBySms.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/loginByMCCPortal',
    name: 'login',
    component: () => import('@/views/loginByPortal.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/downloadPortalApp',
    name: 'login',
    component: () => import('@/views/downloadPortalApp.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/staff',
    name: 'staff',
    icon: 'HomeIcon',
    component: () => import('@/views/staff/index.vue'),
    meta: {
      pageTitle: 'Staff',
    },
  },
  {
    path: '/formCustom',
    name: 'formCustom',
    icon: 'HomeIcon',
    component: () => import('@/components/formCustom/index.vue'),
    meta: {
      pageTitle: 'Staff',
    },
  },
  {
    path: '/worker',
    name: 'worker',
    icon: 'HomeIcon',
    component: () => import('@/views/worker/index.vue'),
    meta: {
      pageTitle: 'Home',
      breadcrumb: [
        {
          text: 'Second Page',
          active: false,
        },
      ],
    },
  },
  {
    path: '/process/index',
    name: 'Audit',
    icon: 'HomeIcon',
    component: () => import('@/views/process/index.vue'),
    meta: {
      pageTitle: 'Audit',
    },
  },
]
